import { apipost } from "../../api";

export const GET_PROJECTS = "GET_PROJECTS";
export const SCARY_MODAL = "SCARY_MODAL";
export const GET_PARTNERS = "GET_PARTNERS";

import { types as kvTypes, actions as kvActions } from "./kv";
import { types as authTypes, actions as authActions } from "./auth";
import { types as partnerTypes, actions as partnerActions } from "./partners";
import { types as contactTypes, actions as contactActions } from "./contacts";
import { types as projectTypes, actions as projectActions } from "./projects";
import { types as flowTypes, actions as flowActions } from "./flow";
import { types as pictureTypes, actions as pictureActions } from "./pictures";
import { types as miscTypes, actions as miscActions } from "./misc";
import { types as basketTypes, actions as basketActions } from "./basket";
import { types as renderTypes, actions as renderActions } from "./render";
import { anyShortCircuit } from "../../util/func";

export default {
  kvActions,
  kvTypes,
  authTypes,
  authActions,
  partnerTypes,
  partnerActions,
  contactTypes,
  contactActions,
  projectTypes,
  projectActions,
  flowTypes,
  flowActions,
  pictureTypes,
  pictureActions,
  miscActions,
  miscTypes,
  basketActions,
  basketTypes,
  renderActions,
  renderTypes
};

/**
 * Applies token to curried named actions
 * @param token
 * @param object
 * @returns {{}}
 */
export const mapTokenize = (token, object) => {
  return Object.keys(object).reduce((actions, action) => {
    actions[action] = object[action](token);
    return actions;
  }, {});
};

/**
 * Blacklist for log requests.
 * @type {RegExp[]}
 */
const logBlackList = [new RegExp(".*GET.*")];

/**
 * Maps actions with tokens while wrapping them into logging middleware
 * @param token
 * @param object
 * @returns {{}}
 */
export const mapLogTokenize = mapTokenize;

/**
 * Wraps an async action with logging facilities
 * @param token
 * @param name
 * @param fn
 * @returns {function(...[*]=): *}
 */
export const wrapLogging = (token, name, fn) => {
  const act = fn(token);
  return async (...args) => {
    if (!anyShortCircuit(logBlackList, reg => reg.test(name)))
      await apipost("/log", { message: name, payload: args.slice(1) }, token);
    return await act(...args);
  };
};
